var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeadRecord = function SvgLeadRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3a3 3 0 0 1 3-3h34a3 3 0 0 1 3 3v34a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z",
    fill: "#EA8F6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.019 16.006a3.003 3.003 0 1 0 0-6.006 3.003 3.003 0 0 0 0 6.006ZM29.361 18.008H10.676c-.667 0-.934.834-.367 1.201l4.872 3.136c.233.167.367.468.267.735l-1.836 6.106c-.2.667.668 1.134 1.168.633l4.738-5.005c.267-.3.734-.3 1.001 0l4.738 5.005c.467.5 1.335.034 1.168-.633l-1.835-6.107a.702.702 0 0 1 .267-.734l4.871-3.136c.567-.367.3-1.201-.367-1.201Z",
    fill: "#fff"
  })));
};
export default SvgLeadRecord;